import register  from '../register.js';
import fbSdk     from './util/fb-sdk';

register( 'bring-me-starry-letter', function() {

  fbSdk.init();

  let cdnURL     = 'https://dyajmw2sca9cs.cloudfront.net';
  let module     = document.querySelector('.js-letterContainer');
  let emailBtn   = module.querySelector('.js-sendEmail');
  let copyBtn    = module.querySelector('.js-copyMessage');
  let letterBody = module.querySelector('.js-letterBody');
  let fbShare    = module.querySelector('.js-facebookShare');

  copyBtn.addEventListener( 'click', ( evt ) => {
    evt.preventDefault();
    let txt = letterBody.innerText;
    copyToClipboard( txt );
  });

  fbShare.addEventListener( 'click', ( evt ) => {

    evt.preventDefault();

    let image = `${ cdnURL }/img/v3/marketing/MYIS-Card.jpg`;
    let desc  = 'Get blazing fast internet for just $50/month';
    let title = 'Make Your Internet Starry';
    let url   = 'https://starry.com?fbShare=true';

    window.FB.ui({
      method: 'share_open_graph',
      action_type: 'og.shares',
      action_properties: JSON.stringify({
        object: {
          'og:url': url,
          'og:title': title,
          'og:description': desc,
          'og:image': image
        }
      })
    });

  });

  emailBtn.addEventListener( 'click', ( evt ) => {
    evt.preventDefault();

    let to      = module.querySelector('input[name="landlord_email"]').value;
    let subject = module.querySelector('.js-subject').innerText;
    let body    = encodeURIComponent( letterBody.innerText );

    sendEmail({ to, subject, body });
  });

});

function copyToClipboard( txt ) {
  let textArea = document.createElement('textarea');
  let copySupported = document.queryCommandSupported('copy');
  let feedbackEl = document.querySelector('.js-copyError');

  if ( !copySupported ) {
    fadeText( feedbackEl, 'Could not copy' );
  }

  textArea.value = txt;
  document.body.appendChild( textArea );
  textArea.select();

  try {
    let success = document.execCommand('copy');
    let msg     = success ? 'Copied!' : 'Oops, could not copy';

    fadeText( feedbackEl, msg );
  } catch ( e ) {
    fadeText( feedbackEl, 'Oops, could not copy' );
  } finally {
    document.body.removeChild( textArea );
  }

};

function fadeText( el, text ) {
  el.classList.add('fade-in');
  el.innerHTML = text;
  el.style.opacity = 1;

  delay( 1000 )
  .then( () => el.style.opacity = 0 )
  .then( () => delay( 800 ) )
  .then( () => el.innerHTML = '' );
}

function delay( ms ) {
  return new Promise( resolve => {
    setTimeout( () => {
      resolve();
    }, ms );
  });
}

function sendEmail( fields ) {
  let defaults = {
    to: '',
    subject: '',
    body: ''
  };

  let { to, subject, body } = Object.assign( {}, defaults, fields );
  let url = `mailto:${ to }?subject=${ subject }&body=${ body }`;

  window.location = url;
}

export default undefined;
